module.exports = "img/button-text-deleted.5774b88.svg";